import deepDiff from 'deep-diff'
import _ from 'lodash'


export default {
    onChange: function(oldState, newState, ignoreKeys) {
        return this.diff(oldState.toJS().document, newState.toJS().document, ignoreKeys)
    },

    diff: function(oldState, newState, ignoreKeys) {
        ignoreKeys = ignoreKeys || []

        return deepDiff.diff(oldState, newState, (path) => {
            return _.includes(ignoreKeys, _.first(path))
        })
    }
}
